<template>
  <main :class="{'projects-page_full': !sidebarOpen}" class="projects-page page-padding page-sidebar">
    <projects-header></projects-header>
    <projects-body></projects-body>
    <p class="btn-hint name-hint btn-hint_bottom btn-hint-navigator">

    </p>
  </main>
</template>

<script>
  import {tokenAndRoute} from "../../mixins/utils/tokenAndRoute";
  import {loaderMixin} from "../../mixins/utils/loaderMixin";
  import projectsHeader from '../../components/Pages/Projects/projectsHeader'
  import projectsBody from '../../components/Pages/Projects/projectsBody'
  import {mapActions} from 'vuex'
  import {sidebarState} from "../../mixins/utils/sidebarState";
  import {pageSettings} from "../../mixins/utils/pageSettings";

  export default {
    name: 'projectsPage',
    mixins: [tokenAndRoute, loaderMixin, sidebarState, pageSettings],
    components: {
      projectsHeader,
      projectsBody
    },
    methods: {
      ...mapActions({
        getUsers: 'roles/getUsers',
        getInvitedUsers: 'roles/getInvitedUsers',
        getProjects: 'projects/getProjects'
      })
    },
    beforeRouteEnter(to, from, next) {
      next(async vm => {
        const param = vm.$route.params.id;


        vm.setFullSidebar(true);
        vm.setRouteName('');

        vm.showLoader()
        await vm.getUsers();
        await vm.getInvitedUsers();
        await vm.getProjects()

        vm.hideLoader()

      })
    }
  }
</script>

<style lang="scss" scoped>
  .projects-page {
    padding-top: 90px;
    padding-left: 240px;
    padding-bottom: 50px;
    padding-right: 0;
  }

  .projects-page_full {
    padding-left: 60px;
  }
</style>
